const normalizeBaseUrl = (rawValue) => {
  if (!rawValue) {
    return '';
  }

  return rawValue.replace(/\/+$/, '');
};

const buildDefaultWebBase = () => {
  if (typeof window === 'undefined') {
    return 'http://localhost:3000';
  }

  return window.location.origin;
};

export const WEB_BASE_URL = normalizeBaseUrl(
  process.env.REACT_APP_WEB_URL || buildDefaultWebBase()
);
